namespace Ir.Components.Workbook.Settings.Items.LinkWorkbooksTabsSetting {
    interface IViewModel {
        treeListConfig: DevExpress.ui.dxTreeList.Properties;
        treeListComponent: DevExpress.ui.dxTreeList;

        textConfig: DevExpress.ui.dxTextBox.Properties;
        textComponent: DevExpress.ui.dxTextBox;
        textValidator: DevExpress.ui.dxValidator.Properties;
        textValidatorComponent: DevExpress.ui.dxValidator;

        workbookTabSelected: KnockoutObservable<ISelectWorkbookTab>

        unsavedTabMessage: KnockoutObservable<boolean>;
        treelistDataSource: KnockoutObservableArray<any>;
    }

    interface IParams {
        getComponent: (viewModel: IViewModel) => void;
    }

    export interface IParamsConfig {
        richConfig: RichTextConfig;
        itemSelected: string;
        textSelected: string;
        rangeSelected: any;
    }

    export interface ISelectWorkbookTab {
        id: number;
        key: string;
        parentKey: string;
        fullName: string;
        name: string;
        tabType: TabTypeEnum;
        widgetType: WidgetType;
        isWorkbook: boolean;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        this.unsavedTabMessage = ko.observable(true);
        this.treelistDataSource = ko.observableArray([]);
        this.workbookTabSelected = ko.observable(null);
        getDataSource(this);

        this.treeListConfig = {
            dataSource: this.treelistDataSource as any,
            keyExpr: 'key',
            parentIdExpr: 'parentKey',
            width: "100%",
            height: this.unsavedTabMessage() ? "calc(100% - 105px)" : "calc(100% - 80px)",
            showColumnHeaders: false,
            searchPanel: {
                visible: true
            },
            filterMode: 'fullBranch',
            selection: {
                mode: 'single',
            },
            showBorders: true,
            scrolling: {
                useNative: false
            },
            columns: [{
                dataField: "name",
                cellTemplate(container, options) {
                    let item = options.data as ISelectWorkbookTab;
                    if (item.isWorkbook) {
                        container.append(`<i class="ms">import_contacts</i> ${item.name}`);
                    }
                    else {
                        container.append(`<i class="ms">${WorkbookTab.getTabIcon(item.tabType, item.widgetType)}</i> ${item.name}`);
                    }
                }
            }],
            onInitialized(e) {
                self.treeListComponent = e.component;
            },
            onSelectionChanged(e) {
                let itemSelected = e.selectedRowsData[0];
                self.workbookTabSelected(itemSelected);
                self.textComponent.option("value", itemSelected?.fullName);
            }
        };

        this.textConfig = {
            labelMode: "outside",
            label: "Text",
            value: null,
            width: "100%",
            onInitialized(e) {
                self.textComponent = e.component;
            }
        };

        this.textValidator = {
            validationRules: [{
                type: 'required',
                message: 'Text is required',
            }],
            onInitialized(e) {
                self.textValidatorComponent = e.component;
            }
        }

        params.getComponent(this);
    }

    function reset(self: IViewModel) {
        self.treeListComponent.clearSelection();
        self.textValidatorComponent.reset();
        self.workbookTabSelected(null);
        self.treeListComponent.option("expandedRowKeys", []);
        self.treeListComponent.getScrollable().scrollTop();
    }

    function getDataSource(self: IViewModel) {
        self.unsavedTabMessage(workbook.workbookConfig.tabs().some(x => x.id() < 0));

        let items = [];
        let o = {
            url: urlConfigs.tabs + "GetWorkbooksAndTabs",
            data: { workbookId: workbook.workbookConfig.workbookId() },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result, e) {
            self.treelistDataSource(result);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get workbooks and tabs";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
        return items;
    }

    async function selectAndFocusRow(self: IViewModel, key, text) {
        const row = self.treeListComponent.getNodeByKey(key);
        if (row.data.parentKey !== "0") {
            await self.treeListComponent.expandRow(row.data.parentKey);
        }

        await self.treeListComponent.selectRows([key], false);
        self.textComponent.option("value", text);

        setTimeout(() => {
            const rowIndex = self.treeListComponent.getRowIndexByKey(key);
            const $row = self.treeListComponent.getRowElement(rowIndex);
            if ($row?.length) {
                self.treeListComponent.getScrollable().scrollToElement($row);
            }
        }, 100);
    }

    let linkWorkbookTabsSetting: IViewModel;
    let linkPopupComponent: DevExpress.ui.dxPopup;
    let paramsConfig: IParamsConfig
    export function show(params: IParamsConfig) {
        paramsConfig = params;
        if (linkPopupComponent) {            
            getDataSource(linkWorkbookTabsSetting);
            linkWorkbookTabsSetting.treeListComponent.option("height", linkWorkbookTabsSetting.unsavedTabMessage() ? "calc(100% - 105px)" : "calc(100% - 80px)");
            linkPopupComponent.show();
            return;
        }

        let popupOptions = {
            width: 400,
            height: 500,
            showTitle: true,
            title: 'Link to open external workbook',
            dragEnabled: false,
            hideOnOutsideClick: false,
            showCloseButton: false,
            visible: false,
            toolbarItems: [{
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Ok',
                    stylingMode: 'outlined',
                    type: 'normal',
                    onClick() {
                        let selected = linkWorkbookTabsSetting.workbookTabSelected();
                        if (selected === null) {
                            DevExpress.ui.notify("Select a workbook or tab");
                            return;
                        }

                        if (linkWorkbookTabsSetting.textValidatorComponent.validate().isValid) {
                            let link = paramsConfig.richConfig.createWorkbookTabLink(selected.id, selected.isWorkbook);

                            let text = linkWorkbookTabsSetting.textComponent.option("value");
                            if (params.itemSelected) {
                                Ir.Components.Workbook.Settings.Items.HtmlEditorSetting.replaceLink(params.rangeSelected, text, link)
                            }
                            else {
                                Ir.Components.Workbook.Settings.Items.HtmlEditorSetting.insertLink(text, link);
                            }

                            linkPopupComponent.hide();
                            reset(linkWorkbookTabsSetting);
                        }
                    }
                },
            }, {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Cancel',
                    stylingMode: 'outlined',
                    type: 'normal',
                    onClick() {
                        linkPopupComponent.hide();
                        reset(linkWorkbookTabsSetting);
                    }
                }
            }],
            onInitialized(e) {
                linkPopupComponent = e.component;
                linkPopupComponent.show();
            },
            onShown(e) {
                if (paramsConfig.itemSelected) {
                    selectAndFocusRow(linkWorkbookTabsSetting, paramsConfig.itemSelected, paramsConfig.textSelected);
                }
            }
        } as DevExpress.ui.dxPopover.Properties;

        let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <link-workbooks-tabs-setting params="getComponent: getComponent"></scheduled-email-filter>
            </div>`);
        $popover.appendTo('body');

        ko.applyBindings({
            popupOptions,
            getComponent(component: IViewModel) {
                linkWorkbookTabsSetting = component;
            }
        }, $popover[0]);
    }
}